import {Dialog, DialogActionsBar, DialogProps} from "@progress/kendo-react-dialogs";
import {ReactNode} from "react";

export default function FlintDialog(props:flintDialogProps){
    return(
        <Dialog {...props}>
            {props.children}
            <DialogActionsBar>
                {props.dialogActionButtons}
            </DialogActionsBar>
        </Dialog>
    )
}

export interface flintDialogProps extends DialogProps{
    dialogActionButtons:ReactNode;
}